document.addEventListener('DOMContentLoaded', () => {
  const animatedNodes = Array.from(document.querySelectorAll('[data-animations]'));
  if (!animatedNodes.length) return;

  const parseAnimations = (value) => {
    try {
      return JSON.parse(value);
    } catch (e) {
      return [];
    }
  };

  const normalizeTime = (val, fallback) => {
    if (!val) return fallback;
    const trimmed = String(val).trim();
    if (!trimmed) return fallback;
    if (/[a-z%]/i.test(trimmed)) return trimmed;
    return `${trimmed}s`;
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const anim = el.__shgAnim;
        if (!anim) return;

        const duration = normalizeTime(anim.duration, '1s');
        const delay = normalizeTime(anim.delay, '0s');
        const iterations = anim.iterationCount && `${anim.iterationCount}`.trim().length
          ? anim.iterationCount
          : 1;

        el.style.animationDuration = duration;
        el.style.animationDelay = delay;
        el.style.animationIterationCount = iterations;
        el.classList.add('shg-anim-active');

        if (anim.shouldBeTriggeredOnce) {
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.15 }
  );

  animatedNodes.forEach((el) => {
    const animations = parseAnimations(el.getAttribute('data-animations'));
    const firstViewport = animations.find((a) => a.event === 'enterviewport') || animations[0];
    if (!firstViewport || !firstViewport.name) return;

    const name = firstViewport.name;
    el.__shgAnim = firstViewport;
    el.classList.add(`shg-anim-${name}`);
    observer.observe(el);
  });
});








